import { GB, ES, DE, FR, IT, type FlagComponent } from 'country-flag-icons/react/3x2';
import supportedLocales from './supported-locales.json';
import { LanguageApiEnum } from '@/types/api';

export interface LocaleMeta {
  name: string;
  Flag: FlagComponent;
  apiEnum: LanguageApiEnum;
}

// Single source of presentation + contract metadata per locale. A locale is ACTIVE only when its
// code is in supported-locales.json AND it has an entry here AND its translation.json folder exists —
// the three-way key-parity test enforces those three sets stay identical, so a new locale is added to
// all three together.
export const LOCALE_META: Record<string, LocaleMeta> = {
  en: { name: 'English', Flag: GB, apiEnum: LanguageApiEnum.ENGLISH },
  es: { name: 'Español', Flag: ES, apiEnum: LanguageApiEnum.SPANISH },
  de: { name: 'Deutsch', Flag: DE, apiEnum: LanguageApiEnum.GERMAN },
  fr: { name: 'Français', Flag: FR, apiEnum: LanguageApiEnum.FRENCH },
  it: { name: 'Italiano', Flag: IT, apiEnum: LanguageApiEnum.ITALIAN },
};

export const SUPPORTED_LOCALE_CODES: string[] = supportedLocales;

export interface LocaleOption extends LocaleMeta {
  code: string;
}

export const LOCALE_OPTIONS: LocaleOption[] = SUPPORTED_LOCALE_CODES.map((code) => {
  const meta = LOCALE_META[code];
  if (!meta) {
    throw new Error(`supported-locales.json lists "${code}" but registry LOCALE_META has no entry for it`);
  }
  return { code, ...meta };
});

export function apiEnumForLanguage(lang: string): LanguageApiEnum {
  const base = lang.split('-')[0] ?? 'en';
  return LOCALE_META[base]?.apiEnum ?? LanguageApiEnum.ENGLISH;
}
